import { EXPERIMENT_COVERAGE_MAP } from "@/common/services/experiment/constants";
import experimentService from "@/common/services/experiment/experimentService";

export function getExperimentVariant(experimentKey: string, fallback: string | boolean) {
  const coverage = EXPERIMENT_COVERAGE_MAP[experimentKey] || 1;
  return experimentService.getVariant(experimentKey, fallback, coverage);
}
